import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationStart, NavigationEnd } from '@angular/router';
import { FormService } from './form.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})

export class AppComponent {

  isMobile:boolean = false;
  isTheme:string = 'vodafone';

  constructor(
    private router : Router,
    private route  : ActivatedRoute,
    private form   : FormService
  ) {}

  ngOnInit() {
    this.isMobile = (window.innerWidth <= 375);

    if (document.location.href.match(/ziggo/) || document.location.href.match(/hcz/)) {
      this.isTheme = 'ziggo';
      this.changeFavIcon('https://www.ziggo.nl/favicon.ico');
    }

    if (this.isTheme == 'vodafone' && document.location.href.match(/www.vodafone.nl\/mijnfeedbackapp/)) {
      this.form.isLive = true;
    }

    if (this.isTheme == 'ziggo' && document.location.href.match(/ziggofeedback.nl\/mijnfeedbackapp/)) {
      this.form.isLive = true;
    }

    this.addTagManager();


    // if (document.location.search) {
    //   this.form.uuid = document.location.search.substring(1);
    // }
    this.route.queryParams.subscribe((params: Params) => {
      this.form.uuid = params['hashedid'];
      this.form.campaignId = params['cpid'];
      // if (params['theme']) {
      //   this.isTheme = params['theme'];
      //   this.form.theme = this.isTheme;
      // }
    });

    this.form.theme = this.isTheme;
  }

  addTagManager() {

    var s1, s2, s3, s4, s5;

    if (this.isTheme == 'ziggo') {
      s1 = document.createElement( 'script' );
      s1.setAttribute('src', '/mijnfeedbackapp/assets/js/ziggo-tags.js');
      document.body.appendChild( s1 );
    }
    if (this.isTheme == 'vodafone') {
      s1 = document.createElement( 'script' );
      s1.setAttribute('src', '../_assets/js/environment/env-tagmanager.js');
      document.body.appendChild( s1 );
      s2 = document.createElement( 'script' );
      s2.setAttribute('src', '../_assets/js/core/tagManager.js');
      document.body.appendChild( s2 );
      }
  }

  submitResponse() {

  }

  changeFavIcon(url:any) {
    (() => {
        var link = document.querySelector("link[rel*='icon']");
        link['href'] = url;
        //document.getElementsByTagName('head')[0].appendChild(link);
    })();
  }

}



// WEBPACK FOOTER //
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/app.component.ts